import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import PhotoLibraryRoundedIcon from '@mui/icons-material/PhotoLibraryRounded';
import PermMediaRoundedIcon from '@mui/icons-material/PermMediaRounded';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import CardMembershipRoundedIcon from '@mui/icons-material/CardMembershipRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import type { SvgIconComponent } from '@mui/icons-material';

export interface AdminNavItem {
  to: string;
  label: string;
  icon: SvgIconComponent;
}

export const adminNavItems: AdminNavItem[] = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: DashboardRoundedIcon },
  { to: '/admin/notifications', label: 'Notifications', icon: NotificationsRoundedIcon },
  { to: '/admin/bookings', label: 'Bookings', icon: AssignmentRoundedIcon },
  { to: '/admin/payments', label: 'Payments', icon: PaymentsRoundedIcon },
  { to: '/admin/reports', label: 'Reports', icon: AnalyticsRoundedIcon },
  { to: '/admin/court-settings', label: 'Court settings', icon: SettingsRoundedIcon },
  { to: '/admin/membership-settings', label: 'Membership', icon: CardMembershipRoundedIcon },
  { to: '/admin/package-settings', label: 'Packages', icon: Inventory2RoundedIcon },
  { to: '/admin/users', label: 'Users', icon: PeopleRoundedIcon },
  { to: '/admin/venue-showcase', label: 'Courts & venues', icon: PhotoLibraryRoundedIcon },
  { to: '/admin/gallery', label: 'Gallery', icon: PermMediaRoundedIcon },
  { to: '/admin/blogs', label: 'Blogs', icon: ArticleRoundedIcon },
];
